module.exports = __webpack_public_path__ + "static/img/2257_phase_function_Paper_Points.86df21c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2257_phase_function_Paper_Points.png
// module id = Fcan
// module chunks = 0